package com.milta.core.localization.translations.de

import com.milta.core.localization.SubscriptionStrings

internal val Subscription = SubscriptionStrings(
    screenTitle = "Mein Abonnement",
    screenSubtitle = "Verwalten Sie Ihr Milta-Abonnement",
    planDriver = "Fahrer",
    planOrganisation = "Unternehmen",
    statusActive = "Aktiv",
    statusTrial = "Kostenlose Testphase",
    statusExpired = "Abgelaufen",
    statusCancelled = "Gekündigt",
    platformLabel = "Plattform",
    productIdLabel = "Produkt",
    expiresAtLabel = "Läuft ab am",
    noExpiry = "Kein Ablaufdatum",
    noValue = "—",
    noSubscription = "Kein aktives Abonnement",
    activateButton = "Abonnement aktivieren",
    successActivated = "Abonnement erfolgreich aktiviert",
    perMonth = "/Monat",
    pitchTitle = "Schalten Sie alle Milta-Funktionen frei",
    pitchSubtitle = "Wählen Sie den Tarif, der zu Ihrer Tätigkeit passt, um weiterhin zuzustellen und Ihre Touren zu verwalten.",
    featuredBadge = "ALLES INKLUSIVE",
    driverFeature1 = "Unbegrenzte Touren & Zustellungen",
    driverFeature2 = "Foto-Zustellnachweis + Unterschrift",
    driverFeature3 = "Echtzeit-Benachrichtigungen",
    orgFeature1 = "Unbegrenzte Teamverwaltung",
    orgFeature2 = "Vollständiges Web-Dashboard",
    orgFeature3 = "Tourenimport (Excel, PDF, Foto)",
    orgFeature4 = "Fahrerzugang für Sie selbst inklusive",
    purchaseFinePrint = "Sichere Zahlung über den Store. Jederzeit über die Store-Einstellungen kündbar.",
    purchasingLabel = "Wird verarbeitet…",
    activeCaption = "Ihr Milta-Abonnement",
    nextRenewalLabel = "Nächste Verlängerung",
    includedTitle = "In Ihrem Tarif enthalten",
    manageOnGooglePlay = "Auf Google Play verwalten",
    manageOnAppStore = "Auf dem App Store verwalten",
    viewTechnicalDetails = "Technische Details anzeigen",
    monthNames = listOf("Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"),
    errorNotFound = "Kein aktives Abonnement gefunden",
    errorConflict = "Für dieses Konto besteht bereits ein aktives Abonnement",
    errorPlanMismatch = "Der ausgewählte Tarif entspricht nicht Ihrer Kontorolle",
    errorPlanRequired = "Bitte wählen Sie einen Tarif aus",
    errorPlanInvalid = "Ungültiger Tarif ausgewählt",
    errorPlatformRequired = "Die Plattform ist erforderlich",
    errorPlatformInvalid = "Ungültige Plattform. Muss AppStore oder GooglePlay sein",
    errorStoreProductIdRequired = "Die Store-Produkt-ID ist erforderlich",
    errorReceiptTokenRequired = "Das Beleg-Token ist erforderlich",
    errorGeneric = "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    trialBannerDaysPrefix = "🎉 Kostenlose Testphase: Ihnen bleiben noch ",
    trialBannerDaysBold = "%d Tage",
    trialBannerDaysSuffix = ", um Milta unverbindlich zu entdecken.",
    trialBannerHoursPrefix = "⏰ Ihre kostenlose Testphase endet in ",
    trialBannerHoursBold = "%dh",
    trialBannerHoursSuffix = ": Abonnieren Sie, um Milta ohne Unterbrechung weiter zu nutzen.",
    coveredByEnterprise = "Durch das Abonnement Ihres Unternehmens abgedeckt",
    myEnterprisesTitle = "Meine Unternehmen",
    enterpriseCoversYou = "Deckt Sie ab",
    enterpriseSubscriptionExpired = "Abonnement abgelaufen",
    myEnterprisesFootnote = "Ihre Unternehmen optimieren die Touren, die sie Ihnen senden, mit ihrem eigenen Guthaben. Ihren Verbrauch sehen Sie nicht.",
    takeDriverPlanForOwnUse = "Um Ihre eigenen Touren zu optimieren und die KI selbst zu nutzen, schließen Sie ein Fahrer-Abonnement ab.",
    ownPlanNotNeededWhenCovered = "Sie sind durch Ihr Unternehmen abgedeckt, Ihr persönliches Abonnement ist nicht nötig. Es dient für die Optimierungen, die Sie selbst starten.",
)
